/**
 * Created by Jerker Nord on 2021-01-27.
 */
import {NolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/NolimitAudioPlayer";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {NolimitHowl} from "@nolimitcity/slot-audio/bin/NolimitHowl";
import {NamedLogger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {gsap} from "gsap";
import {LoopableList} from "../../utils/LoopableList";
import {BS2GameMode} from "../../server/BS2GameMode";
import {BS2} from "../../BS2";
import {BetFeature} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";
import {BS2Statics} from "../BS2Statics";


export class BS2Sound {

    public static AS_WIN:string = "asWin";
    public static AS_WIN_BIG:string = "asWinBig";

    public static REELS_OUT:string = "reelsOut";
    public static REELS_IN:string = "reelsIn";

    static WIN_LINE:LoopableList<string> = new LoopableList([
        "winLine1",
        "winLine2",
        "winLine3",
        "winLine4",]).setRandomizeAtWrapAround(false);

    public static REELS_LANDING:LoopableList<string> = new LoopableList([
        "reelLanding1",
        "reelLanding2",
        "reelLanding3",
        "reelLanding4",
        "reelLanding5",
        "reelLanding6",
        "reelLanding7",
        "reelLanding8",
        "reelLanding9",
        "reelLanding10",
        "reelLanding11",]).setRandomizeAtWrapAround(true);

    public static SYM_COLLAPSE:LoopableList<string> = new LoopableList([
        "symCollapse1",
        "symCollapse2",
        "symCollapse3",
        "symCollapse4",
        "symCollapse5",
        "symCollapse6",
        "symCollapse7",
        "symCollapse8",
        "symCollapse9",
        "symCollapse10",
        "symCollapse11"]).setRandomizeAtWrapAround(true);

    public static SYM_LAND_NEAR_WIN:LoopableList<string> = new LoopableList([
        "reelLandAnticipation01",
        "reelLandAnticipation02",
        "reelLandAnticipation03",
        "reelLandAnticipation04"]).setRandomizeAtWrapAround(true);


    public static SCATTER_LANDING_S1 = [
        "s1Land1",
        "s1Land2",
        "s1Land3",
    ];

    public static SCATTER_LANDING_S2 = [
        "s2Land1",
        "s2Land2",
        "s2Land3",
    ];

    static POTENTIAL_WIN:string[] = [
        "",
        "potentialWin2",
        "potentialWin3",
        "potentialWin4",
        "potentialWin5",
    ];

    public static W_LANDING:LoopableList<string> = new LoopableList([
        "wildLand01",
        "wildLand02",
        "wildLand03"
    ]).setRandomizeAtWrapAround(true);

    public static SYM_TRANSFORM:LoopableList<string> = new LoopableList([
        "symTransform01",
        "symTransform02",
        "symTransform03"
    ]).setRandomizeAtWrapAround(true);

    public static WILD_STICKY:LoopableList<string> = new LoopableList([
        "wildSticky01",
        "wildSticky02",
        "wildSticky03"
    ]).setRandomizeAtWrapAround(false);

    public static SCATTER_COLLAPSE:LoopableList<string> = new LoopableList([
        "scatterCollapse01",
        "scatterCollapse02",
        "scatterCollapse03"
    ]).setRandomizeAtWrapAround(true);

    public static S_LANDING:LoopableList<string> = new LoopableList([
        "scatterLand01",
        "scatterLand02",
        "scatterLand03"]).setRandomizeAtWrapAround(true);

    public static S_PLUS_ONE: string = "scatterPlusOne";

    public static G_LAND: string = "xsplitReelLand";
    public static G_BUILDUP: string = "xsplitReelBuildup";
    public static G_SPLIT: string = "xsplitReelSplit";

    public static D_LAND: string = "xsplitRowLand";
    public static D_BUILDUP: string = "xsplitRowBuildup";
    public static D_SPLIT: string = "xsplitRowSplit";

    public static X_SPLIT_X2: string = "xsplitX2";
    public static X_SPLIT_TO_WILD: string = "xsplitToWild";

    public static REEL_START = "reelsStart";
    public static REEL_SPINNING = "reelsSpinning";
    public static REEL_STOP = "reelsStop";

    public static MAIN_GAME_MUSIC:string = "background-music-main";
    public static FREESPIN_MUSIC:string = "background-music-fs";
    public static SFS_REMOVE_ROW:string = "sfsRemoveRow";

    static COUNT_UP:string = "countup";
    static COUNT_UP_ENDS_LARGE:string = "countupEndsLarge";
    static COUNT_UP_ENDS_MEDIUM:string = "countupEndsMedium";
    static COUNT_UP_ENDS_SMALL:string = "countupEndsSmall";
    static COUNT_UP_ENDS_TINY:string = "countupEndsTiny";

    private _currentLevelLoop:string | undefined;
    private _currentMusic:string;
    private _currentXbetLoopMusic:string|undefined;
    private player:NolimitAudioPlayer;
    private logger:NamedLogger;
    static WIN_HIGHLIGHT_TINY:string = "winHighLightTiny";
    static WIN_HIGHLIGHT_SMALL:string = "winHighLightSmall";
    static WIN_HIGHLIGHT_MEDIUM:string = "winHighLightMid";
    static WIN_HIGHLIGHT_LARGE:string = "winHighLightLarge";
    static WIN_TINY:string = "winTiny";
    static WIN_SMALL:string = "winSmall";
    static WIN_MEDIUM:string = "winMid";
    static WIN_LARGE:string = "winLarge";

    static SYMBOL_DRAIN:string = "symDrain";
    static WIN_REMOVE_BY_RATIO:string [] = [
        "winRemoveTiny",
        "winRemoveSmall",
        "winRemoveMid",
        "winRemoveLarge"
    ];



    static BIG_WIN_INTRO:string = "bigwinIntro";
    static BIG_WIN_LEVEL_1:string = "bigwin1";
    static BIG_WIN_LEVEL_2:string = "bigwin2";
    static BIG_WIN_LEVEL_3:string = "bigwin3";
    static BIG_WIN_LEVEL_4:string = "bigwin4";
    static BIG_WIN_LEVEL_5:string = "bigwin5";
    static BIG_WIN_END:string = "bigwinEnd";

    private countUpLoop:NolimitHowl | undefined;
    private currentWinSound:string;

    static CONTINUE_BUTTON:string = "continueButton";
    static HP_ADD_PREFIX:string = "hpAdd";
    static HP_REMOVE_PREFIX:string = "hpRemove";


    static FS_SCATTER_MOVE:string = "scatterMoveFS";
    static FS_WIN:string = "scatterWin";
    static FS_RE_TRIGGER:string = "fsRetrigger";
    static FS_RE_TRIGGER_LAND:string = "fsRetriggerLand";
    static FS_RE_TRIGGER_END:string = "fsRetriggerEnd";

    static FS_SYM_POP_UP:string = "fsSymPopUp";
    static FS_SYM_POP_DOWN:string = "fsSymPopBack";



    static ANTICIPATION_START:string = "scatterAnticipation";
    static ANTICIPATION_END:string = "scatterAnticipationFail";
    static WILD_MINING:string = "wildMining";


    static FS_COLLECT_TINY:string = "fsWinCollectTiny";
    static FS_COLLECT_SMALL:string = "fsWinCollectSmall";
    static FS_COLLECT_MEDIUM:string = "fsWinCollectMedium";
    static FS_COLLECT_LARGE:string = "fsWinCollectLarge";

    static BROKE_BANK_COUNTUP:string = "capWinCountup";
    static BROKE_BANK_LOOP:string = "capWinLoop";
    static BROKE_BANK_END:string = "capWinEnd";
    static X_BET_SCATTER_LAND:string = "s1LandXbet";

    static WILD_UNLOCK:string = "wildUnlock";
    static LEVEL_RESET:string = "lvlReset";
    static EASTER_EGG:string = "easteregg";

    static SFS_END:string = "fsEnd";
    static SFS_LOOP:string = "sfsLoop";
    static SFS_INTRO_LOOP:string = "sfsIntroLoop";
    static SFS_END_MUSIC_BAD:string = "sfsOutroStartBad";
    static SFS_END_MUSIC_GOOD:string = "sfsOutroStartGood";
    static SFS_OUTRO_LOOP:string = "sfsOutroLoop";
    static XBET2_LOOP:string = "xbet2Loop";

    static SFS_INTRO_START:string = "sfsIntroStart";
    static SFS_INTRO_THUNDER:string = "sfsIntroThunder";

    static SFS_START:string = "sfsStart";
    static SFS_HEART:string = "sfsIntroHeartbeat";
    static SFS_BREAK_BAR:string = "sfsRemoveRow";
    static SFS_OUTRO_END:string = "sfsOutroEnd";


    static BOOST_OFF:string = "xBetOff";
    static BOOST_ON:string = "xBetOn";
    public _nearWinStarted:boolean = false;
    public static NEAR_WIN_ANTICIPATION:string = "nearWinAnticipation";
    public static NEAR_WIN_ANTICIPATION_END:string = "nearWinAnticipationEnd";


    public static RITUAL_END = "ritualEnd";
    public static RITUAL_START_1 = "ritualStart1";
    public static RITUAL_START_2 = "ritualStart2";
    public static RITUAL_START_3 = "ritualStart3";
    public static RITUAL_START_4 = "ritualStart4";

    public static RITUAL_LOOP_1 = "ritualLoop1";
    public static RITUAL_LOOP_2 = "ritualLoop2";
    public static RITUAL_LOOP_3 = "ritualLoop3";
    public static RITUAL_LOOP_4 = "ritualLoop4";
    private ritualLoops:(NolimitHowl|undefined)[] = [];
    static LEVEL_METER_UP:string[] = [
        "lvlMeterUp1",
        "lvlMeterUp2",
        "lvlMeterUp3",
        "lvlMeterUp4",
    ];

    public static LEVEL_METER_SWOOSH:LoopableList<string> = new LoopableList([
        "lvlMeterSwoosh01",
        "lvlMeterSwoosh02",
        "lvlMeterSwoosh03"
    ]).setRandomizeAtWrapAround(true);

    public static LEVEL_UP:string[] = [
        "lvlUp1",
        "lvlUp2",
        "lvlUp3",
        "lvlUp4",
        "lvlUp5"
    ];

    static LEVEL_UP_SHORT:string[] = [
        "lvlUpShort1",
        "lvlUpShort2",
        "lvlUpShort3",
        "lvlUpShort4",
        "lvlUpShort5"
    ];

    static RESPIN_ADD_WOOSH:string = "respinWoosh";
    static CANDLES_BG_BLOWOUT:string = "candlesBlowOut";
    private static davidPanningReelStop: number[] = [-0.14, -0.07, -0.01, 0.01, 0.07, 0.14];


    constructor() {
        this.player = <NolimitAudioPlayer>SlotGame.sound;
        this.logger = new NamedLogger("DCSound");
    }


    private static createConfig(name:string, volume?:number, fVolume?:number, repeat?:number, fadeDur?:number) {
        return {
            name:name,
            volume:volume,
            fVolume:fVolume,
            repeat:repeat,
            fadeDurr:fadeDur
        }
    }

    public playReelStopSound(reel: number, volume?:number, fadeVolume?:number, repeat?:number, fadeDuration?:number) {
        const soundName = BS2Sound.REELS_LANDING.next();
        const sound: NolimitHowl | undefined =  this.player.playTrack(BS2Sound.createConfig(soundName, volume, fadeVolume, repeat, fadeDuration));
        if (sound) {
            this.logger.log("playReelStopSound: " + reel);
            sound.player.stereo(BS2Sound.davidPanningReelStop[reel])
        }
    }

    public playSymCollapseSound(reel: number, volume?:number, fadeVolume?:number, repeat?:number, fadeDuration?:number) {
        const soundName = BS2Sound.SYM_COLLAPSE.next();
        const sound: NolimitHowl | undefined =  this.player.playTrack(BS2Sound.createConfig(soundName, volume, fadeVolume, repeat, fadeDuration));
        if (sound) {
            this.logger.log("playSymCollapseSound: " + reel);
            sound.player.stereo(BS2Sound.davidPanningReelStop[reel])
        }
    }

    public playSoundWithPan(soundName:string, reel:number, volume?:number, fadeVolume?:number, repeat?:number, fadeDuration?:number) {
        const sound: NolimitHowl | undefined =  this.player.playTrack(BS2Sound.createConfig(soundName, volume, fadeVolume, repeat, fadeDuration));
        if (sound) {
            this.logger.log("playSoundWithPan: " + reel);
            sound.player.stereo(BS2Sound.davidPanningReelStop[reel])
        }
    }

    public playWildLandingSound(reel: number, volume?:number, fadeVolume?:number, repeat?:number, fadeDuration?:number) {
        const soundName = BS2Sound.W_LANDING.next();
        const sound: NolimitHowl | undefined =  this.player.playTrack(BS2Sound.createConfig(soundName, volume, fadeVolume, repeat, fadeDuration));
        if (sound) {
            this.logger.log("playWildLandingSound: " + reel);
            sound.player.stereo(BS2Sound.davidPanningReelStop[reel])
        }
    }

    public playScatterLandingSound(reel: number, volume?:number, fadeVolume?:number, repeat?:number, fadeDuration?:number) {
        const soundName = BS2Sound.S_LANDING.next();
        const sound: NolimitHowl | undefined =  this.player.playTrack(BS2Sound.createConfig(soundName, volume, fadeVolume, repeat, fadeDuration));
        if (sound) {
            this.logger.log("playScatterLandingSound: " + reel);
            sound.player.stereo(BS2Sound.davidPanningReelStop[reel])
        }
    }

    public playLoopingSound(name:string, volume?:number, fadeVolume?:number, repeat?:number, fadeDuration?:number):void {
        this.playAndGetLoopingSound(name, volume, fadeVolume, repeat, fadeDuration);
    }

    public playAndGetLoopingSound(name:string, volume?:number, fadeVolume?:number, repeat?:number, fadeDuration?:number):NolimitHowl | undefined {
        const sound = this.playAndGetSound(name, volume, fadeVolume, repeat, fadeDuration);
        if (sound) {
            sound.setLoop(true);
        }
        return sound;
    }

    public playSound(name:string, volume?:number, fadeVolume?:number, repeat?:number, fadeDuration?:number):void {
        this.playAndGetSound(name, volume, fadeVolume, repeat, fadeDuration);
    }

    public playAndGetSound(name:string, volume?:number, fadeVolume?:number, repeat?:number, fadeDuration?:number):NolimitHowl | undefined {
        this.logger.log("playSound: " + name);
        return this.player.playTrack(BS2Sound.createConfig(name, volume, fadeVolume, repeat, fadeDuration));
    }

    public stopSound(name:string, fadeOutMS:number = 0) {
        this.logger.log("stopSound: " + name);
        if (fadeOutMS > 0) {
            const tl = gsap.timeline();
            tl.add(() => {
                this.player.fadeTrack({name:name, to:0, duration:fadeOutMS})
            });
            tl.add(() => {
                this.player.stopTrack(name)
            }, fadeOutMS * 0.001);

        } else {
            this.player.stopTrack(name);
        }
    }

    public switchMusic(mode:GameMode | string) {
        let nextMusic = "";

        switch (mode) {
            case BS2GameMode.FREESPIN_SUPER:
                nextMusic = BS2Sound.SFS_LOOP;
                break;
            case BS2GameMode.AVALANCHE_FREESPIN_SUPER:
                nextMusic = BS2Sound.SFS_LOOP;
                break;
            case GameMode.FREESPIN:
                nextMusic = BS2Sound.FREESPIN_MUSIC;
                break;
            default:
                nextMusic = BS2Sound.MAIN_GAME_MUSIC;
                break;
        }

        if (nextMusic == this._currentMusic) {
            return;
        }

        if (this._currentMusic) {
            this.player.stopTrack(this._currentMusic);
        }
        this.logger.log("switch to sound: " + nextMusic);
        this.player.playTrack(BS2Sound.createConfig(nextMusic, 1, undefined));
        this._currentMusic = nextMusic;
    }


    public playWinSound(name:string) {
        this.stopWinSound();
        this.playSound(name);
        this.currentWinSound = name;
    }

    public stopWinSound() {

        this.stopSound(this.currentWinSound);
    }

    public startCountUp() {
        this.countUpLoop = this.playAndGetSound(BS2Sound.COUNT_UP);
        if (this.countUpLoop) {
            this.countUpLoop.setLoop(true);
        }
    }

    public endCountUp(endSound:string) {
        if (this.countUpLoop) {
            if (endSound != "") {
                this.playSound(endSound);
            }
            this.stopSound(BS2Sound.COUNT_UP, 50);
            delete this.countUpLoop;
        }
    }

    public fadeOutMusic(duration:number = 300, targetVolume:number = 0) {
        if (this._currentMusic) {
            this.player.fadeTrack({
                name:this._currentMusic,
                to:targetVolume,
                duration:duration
            });
        }

        if (this._currentLevelLoop){
            this.player.fadeTrack({
                name:this._currentLevelLoop,
                to:targetVolume,
                duration:duration
            });
        }
        this.logger.log("fadeOutMusic sound: " + this._currentMusic);

    }

    public fadeInMusic(duration:number = 300,isxbet:boolean=false) {
        if (this._currentMusic) {
            this.player.fadeTrack({
                name:this._currentMusic,
                to:1,
                duration:duration
            });
        }

        if (this._currentLevelLoop && !isxbet){
            this.player.fadeTrack({
                name:this._currentLevelLoop,
                to:1,
                duration:duration
            });
        }
        this.logger.log("fadeInMusic sound: " + this._currentMusic);
    }

    public startNearWin() {
        if (!this._nearWinStarted) {
            this._nearWinStarted = true;
            this.playSound(BS2Sound.NEAR_WIN_ANTICIPATION);
            this.fadeOutMusic(500, 0.5);
        }
    }

    public stopNearWin(nextMode:BS2GameMode) {
        if (this._nearWinStarted) {
            this._nearWinStarted = false;
            this.stopSound(BS2Sound.NEAR_WIN_ANTICIPATION);
            this.fadeInMusic(10);
            this.playSound(BS2Sound.NEAR_WIN_ANTICIPATION_END);

  /*          if (nextMode != BS2GameMode.FREESPIN && nextMode != BS2GameMode.SUPER_FREESPIN) {
                this.playSound(BS2Sound.NEAR_WIN_ANTICIPATION_FAIL);
            }*/

        }
    }


    stopLevel(playStopSound:boolean = true){
        const activeBetFeature :BetFeature|undefined=BS2.apiPlugin.betFeatureController.getActiveBetFeature();
        if (playStopSound && activeBetFeature?.name !== BS2Statics.BOOSTED_BET_1 && activeBetFeature?.name !==BS2Statics.BOOSTED_BET_2 ){
            if(!BS2.isWinBelowStake()){
                this.playSound(BS2Sound.RITUAL_END);
            }
        }
        this._currentLevelLoop = undefined;
        this._currentXbetLoopMusic=undefined;
        if(activeBetFeature?.name===BS2Statics.BOOSTED_BET_1){
            if(!BS2.isWinBelowStake()){
                BS2.soundPlayer.playSound(BS2Sound.RITUAL_START_1);
            }
            this.fadeInLoopMusic(BS2Sound.RITUAL_LOOP_1,1,100);
            this.player.fadeTrack({name: BS2Sound.RITUAL_LOOP_2, to: 0,duration: 50});
            this.player.fadeTrack({name: BS2Sound.RITUAL_LOOP_3, to: 0,duration: 50});
            this.player.fadeTrack({name: BS2Sound.RITUAL_LOOP_4, to: 0,duration: 50});
        }
        else{
            this.player.fadeTrack({name: BS2Sound.RITUAL_LOOP_1, to: 0,duration: 1});
            this.player.fadeTrack({name: BS2Sound.RITUAL_LOOP_2, to: 0,duration: 1});
            this.player.fadeTrack({name: BS2Sound.RITUAL_LOOP_3, to: 0,duration: 1});
            this.player.fadeTrack({name: BS2Sound.RITUAL_LOOP_4, to: 0,duration: 1});
        }
    }

    playSfsIntroLoop(){
        this.logger.log("playSfsIntroLoop sound");
        this.player.playTrack({name: BS2Sound.SFS_INTRO_LOOP, volume:0});
        this.player.fadeTrack({name: BS2Sound.SFS_INTRO_LOOP, to: 1,duration: 50});
    }

    playLoopMusic(name:string){
        if(this._currentXbetLoopMusic===name){
            return;
        }
        this.logger.log("playLoopMusic sound: ",name);
        this.player.playTrack({name: name, volume:0});
    }
    fadeInLoopMusic(name:string,volume:number,duration:number = 200){
        if(this._currentXbetLoopMusic===name){
            return;
        }
        this._currentXbetLoopMusic=name;
        this.logger.log("fadeInLoopMusic sound, ",name);

        this.player.fadeTrack({name: name, to: volume,duration: duration})
    }
    fadeOutLoopMusic(name:string,duration:number = 3000) {
        this.logger.log("fadeOutLoopMusic sound, ",name);
        this.player.fadeTrack({name: name, to:0, duration:duration});
        this._currentXbetLoopMusic=undefined;
    }

    stopSfsIntroLoop(){
        this.logger.log("stopSfsIntroLoop sound");
        this._currentXbetLoopMusic=undefined;
        this.player.fadeTrack({name: BS2Sound.SFS_INTRO_LOOP, to: 0,duration: 50});
        this.player.stopTrack(BS2Sound.SFS_INTRO_LOOP);
    }

    stopXBet2Loop(){
        this.logger.log("stoxbet2Loop sound");
        this.player.fadeTrack({name: BS2Sound.XBET2_LOOP, to: 0,duration: 50});
        this.player.stopTrack(BS2Sound.XBET2_LOOP);
    }
    stopXBet1Loop(){
        this.logger.log("stoxbet1Loop sound: ritualloop1");
        this.player.fadeTrack({name: BS2Sound.RITUAL_LOOP_1, to: 0,duration: 50});
        this.player.stopTrack(BS2Sound.RITUAL_LOOP_1);
    }

    playSfsOutroLoop(){
        this.logger.log("playSfsOutroLoop sound");
        this.player.playTrack({name: BS2Sound.SFS_OUTRO_LOOP, volume:0});
        this.player.fadeTrack({name: BS2Sound.SFS_OUTRO_LOOP, to: 1,duration: 50});
    }

    stopSfsOutroLoop(){
        this.logger.log("stopSfsOutroLoop sound");
        this.player.fadeTrack({name: BS2Sound.SFS_OUTRO_LOOP, to: 0,duration: 50});
        this.player.stopTrack(BS2Sound.SFS_OUTRO_LOOP);
    }

    startLevel(level:number) {
        if (level == 0 || level > 4){
            this.stopLevel(false);
            return;
        }

        this.player.playTrack({name: BS2Sound.RITUAL_LOOP_1, volume:0});
        this.player.playTrack({name: BS2Sound.RITUAL_LOOP_2, volume:0});
        this.player.playTrack({name: BS2Sound.RITUAL_LOOP_3, volume:0});
        this.player.playTrack({name: BS2Sound.RITUAL_LOOP_4, volume:0});

        if (level == 1){
            this.playSound(BS2Sound.RITUAL_START_1);
            this._currentLevelLoop = BS2Sound.RITUAL_LOOP_1;
            this.fadeInLoopMusic(BS2Sound.RITUAL_LOOP_1,1,100);
            this.logger.log("playLoop sound: " + BS2Sound.RITUAL_LOOP_1);
            this.player.fadeTrack({name: BS2Sound.RITUAL_LOOP_2, to: 0,duration: 500});
            this.player.fadeTrack({name: BS2Sound.RITUAL_LOOP_3, to: 0,duration: 500});
            this.player.fadeTrack({name: BS2Sound.RITUAL_LOOP_4, to: 0,duration: 500});

        }
        if (level == 2){
            this.playSound(BS2Sound.RITUAL_START_2);
            this._currentLevelLoop = BS2Sound.RITUAL_LOOP_2;
            this.fadeOutLoopMusic(BS2Sound.RITUAL_LOOP_1,500);
            this.player.fadeTrack({name: BS2Sound.RITUAL_LOOP_2, to: 1,duration: 100});
            this.logger.log("playLoop sound: " + BS2Sound.RITUAL_LOOP_2);
            this.player.fadeTrack({name: BS2Sound.RITUAL_LOOP_3, to: 0,duration: 500});
            this.player.fadeTrack({name: BS2Sound.RITUAL_LOOP_4, to: 0,duration: 500});

        }
        if (level == 3){
            this.playSound(BS2Sound.RITUAL_START_3);
            this._currentLevelLoop = BS2Sound.RITUAL_LOOP_3;
            this.fadeOutLoopMusic(BS2Sound.RITUAL_LOOP_1,500);
            this.player.fadeTrack({name: BS2Sound.RITUAL_LOOP_2, to: 0,duration: 500});
            this.player.fadeTrack({name: BS2Sound.RITUAL_LOOP_3, to: 1,duration: 100});
            this.logger.log("playLoop sound: " + BS2Sound.RITUAL_LOOP_3);
            this.player.fadeTrack({name: BS2Sound.RITUAL_LOOP_4, to: 0,duration: 500});
        }
        if (level == 4){
            this.playSound(BS2Sound.RITUAL_START_4);
            this._currentLevelLoop = BS2Sound.RITUAL_LOOP_4;
            this.fadeOutLoopMusic(BS2Sound.RITUAL_LOOP_1,500);
            this.player.fadeTrack({name: BS2Sound.RITUAL_LOOP_2, to: 0,duration: 500});
            this.player.fadeTrack({name: BS2Sound.RITUAL_LOOP_3, to: 0,duration: 500});
            this.player.fadeTrack({name: BS2Sound.RITUAL_LOOP_4, to: 1,duration: 100});
            this.logger.log("playLoop sound: " + BS2Sound.RITUAL_LOOP_4);
        }


    }
}